import { isEmpty } from 'lodash';

import { BLUECONIC_CONTENT_COLLECTOR_ID } from '@src/env';
import { getRecommendedArticles } from '@utils/backend-api/articles';

const BLUECONIC_BREAKING_NEWS_ALGORITHM = 'RECENT_VIEW';
export const MINIMUM_RECOMMENDED_ARTICLES = 4;

export interface BlueconicRecommendation {
  category: string;
  description: string;
  id: string;
  image: string;
  name: string;
  publicationDate: string;
  recommendationId: string;
  score: number;
  setId: string;
  trackingUrl: string;
  url: string;
}

export const getBlueconicRecommendations = async () => {
  let url = window.location.href;
  const paramIndex = url.indexOf('?');
  if (paramIndex !== -1) {
    url = url.substring(0, paramIndex);
  }

  const recommendations: BlueconicRecommendation[] = await triggerBlueconicRecommendation(url);

  if (isEmpty(recommendations)) {
    return [];
  }

  const slugs = recommendations.slice(0, 4).map(({ id }) => {
    const urlParts = id.split('/');
    return urlParts[urlParts.length - 1];
  });

  const articles = await getRecommendedArticles({ articleSlugs: slugs });
  return articles;
};

const triggerBlueconicRecommendation = async (
  currentLink: string
): Promise<BlueconicRecommendation[]> => {
  return new Promise((resolve, reject) => {
    try {
      if (window.blueConicClient) {
        window.blueConicClient.recommendation.getRecommendations(
          {
            profileId: window.blueConicClient.profile.getProfile().getId(),
            storeId: BLUECONIC_CONTENT_COLLECTOR_ID, // Content Collector Id
            itemId: currentLink, // Current URL of Article Or Briefing

            request: [
              {
                id: 'first',
                boosts: [
                  {
                    value: 1,
                    algorithm: BLUECONIC_BREAKING_NEWS_ALGORITHM,
                  },
                ],
                filters: ['SAME_CATEGORY', 'docType:articles'], // Same Category and Document Type should be article
                count: MINIMUM_RECOMMENDED_ARTICLES,
              },
            ],
            frequencyCap: 1000,
          },
          (response) => resolve(response.getItems())
        );
      } else {
        resolve([]);
      }
    } catch (error) {
      reject(error);
    }
  });
};
